import { IApplicationState } from '../../types/redux';

export const selectAreaFilters = (state: IApplicationState) => {
  const { savedFilters } = state.filters;

  return {
    areaFrom: savedFilters.areaFrom,
    areaTo: savedFilters.areaTo,
  };
};
